// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7095e41b","453":"a028a912"}[chunkId] + ".chunk.js";
};